import { useQuery } from '@tanstack/react-query';
import getRoutesHistory from './getRoutesHistory';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import moneyParser from '../../../../utils/moneyParser';

export default function useGetRoutesHistory(filters) {
  const { username } = useSelector((state) => state.auth);

  return useQuery({
    queryKey: ['routes-history', filters],
    queryFn: () =>
      getRoutesHistory({
        ...filters,
        start: filters.start ? dayjs(filters.start).format('YYYY-MM-DD') : '',
        end: filters.end ? dayjs(filters.end).format('YYYY-MM-DD') : '',
        id_clouder: username,
      }),
    select: (data) => {
      return {
        ...data,
        data: {
          ...data.data,
          rows: data.data.routes.map((route) => ({
            ...route,
            price: `$${moneyParser(route.price)}`,
            created_at: dayjs(route.createdAt).format('DD/MM/YYYY'),
          })),
        },
      };
    },
  });
}
